// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GQ3jW","spin":"Spinner_spin__Q9zsz","container":"Spinner_container__k-afu"};